import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nb from './translations/nb/translation.json';
import nn from './translations/nn/translation.json';
import en from './translations/en/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      nb: { translation: nb },
      nn: { translation: nn },
      en: { translation: en }
    },
    fallbackLng: 'nb',
    interpolation: {
      escapeValue: false
    }
  })
  .catch((error) => console.error("i18n initialization failed:", error));

export default i18n;
